module.exports = __webpack_public_path__ + "img/drd0wney-website-header.beb95afa.png";